module.exports = __webpack_public_path__ + "static/media/calendar.5398969e.svg";